import React from "react";
//====================================================================
import { types } from "react-bricks/frontend";
import styled from "styled-components";
import {
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import { restrictedBackgroundColorProp } from "../utils/backgroundColor";
import Button from "../common/Button";
import { mobile } from "components/templates/Breakpoints";

interface ButtonStripProps {
  paddingVertical: VerticalPadding;
  link: string;
  label: string;
  backgroundColor: types.IColor;
  variant?: "primary" | "secondary" | "inverted" | "purple" | "menu" | "purpleInverted" | "white";
}

const ButtonStrip: types.Brick<ButtonStripProps> = ({
  link,
  label,
  paddingVertical,
  backgroundColor,
  variant,
}) => {
  return (
    <VerticalPaddingWrapper
      paddingVertical={paddingVertical}
      backgroundColor={backgroundColor?.color}
    >
      <Container>
        <Button text={label} href={link} variant={variant} />
      </Container>
    </VerticalPaddingWrapper>
  );
};

ButtonStrip.schema = {
  // Unique brick name
  name: "buttonstrip",
  label: "Button Strip",
  previewImageUrl: "/static/bricks/button.png",
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    link: "#",
    label: "Click Me",
    variant: "primary",
  }),

  // Sidebar Edit controls for props
  sideEditProps: [
    verticalPadSideProp,
    restrictedBackgroundColorProp,
    {
      name: "link",
      label: "Link",
      type: types.SideEditPropType.Text,
    },
    {
      name: "label",
      label: "Label",
      type: types.SideEditPropType.Text,
    },
    {
      name: "variant",
      label: "Button Variant",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Select,
        options: [
          { value: "primary", label: "Primary" },
          { value: "secondary", label: "Secondary" },
          { value: "inverted", label: "Inverted" },
          { value: "purple", label: "Purple" },
          { value: "menu", label: "Menu" },
          { value: "purpleInverted", label: "Purple Inverted" },
          { value: "white", label: "White" },
        ],
      },
    },
  ],
};

export default ButtonStrip;

const Container = styled.div`
  align-items: center;
  button {
    margin: auto;
  }

  ${mobile} {
    button {
      width: calc(100% - 4rem);
    }
  }
`;
